import React from 'react'
import { Box, Flex } from '@workwhile/ui'
import { Header } from 'components/Header'
import { JurisdictionInfoCard } from './JurisdictionInfoCard'
import { ActiveRulesTable } from './ActiveRulesTable'
import { useJurisdictionDetailContextValue } from '../context/JurisdictionDetailProvider'

const JurisdictionDetailHeader = () => {
  const { state } = useJurisdictionDetailContextValue()

  return (
    <Header
      title={`${state.name} (${state.id})`}
      subTitle="Wage Jurisdiction"
    />
  )
}

export const JurisdictionDetailMain = () => {
  return (
    <>
      <JurisdictionDetailHeader />
      <Box margin={3}>
        <Flex gap={3} wrap="wrap">
          <JurisdictionInfoCard />
        </Flex>
        <Flex gap={3} wrap="wrap" marginTop={3}>
          <ActiveRulesTable />
        </Flex>
      </Box>
    </>
  )
}
